import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-delete-modal',
  templateUrl: './shared-delete-modal.component.html',
  styleUrl: './shared-delete-modal.component.scss',
  standalone: false
})
export class SharedDeleteModalComponent {
  public data: { title: string; messageTitle: string; message: string; buttonText: string; cancelButtonText?: string } =
    inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<SharedDeleteModalComponent>);

  constructor() {}

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
